const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

function isGa4Enabled() {
  return Boolean(GA4_MEASUREMENT_ID) && typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function initGA4() {
  if (!isGa4Enabled() || window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    page_path: window.location.pathname + window.location.search,
    page_title: document.title
  });
}

export function trackPageView(location = window.location) {
  if (!isGa4Enabled() || !window.gtag) return;

  const pagePath = `${location.pathname || '/'}${location.search || ''}`;
  window.gtag('config', GA4_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: document.title
  });
}
